import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { activateCTStudent, initCT, uploadToS3, LibraryinitVoice, pingCriticalThinking, resultCT, submitActivity, librarySubmitLesson, initiateQuiz } from "../../resources/api";
import { CorrectIcon, RecordIcon, CTLessonIntro, WrongIcon } from "../../resources/svgs";
import useCountDown from "../../utils/countdown";
import Lottie from "react-lottie";
import clsx from "clsx";
import { formatTime } from "../../utils/common";
import * as processingAnimation from "../../lottie/processing.json";
import styles from '../../styles/Lesson.module.css'
import * as SpeechSDK from "microsoft-cognitiveservices-speech-sdk";
import useStickyState from "../../utils/stickyState";
import { useSoundManager } from "../../utils/sound";
import { playSound } from "../../utils/playsound";
import FlipNumbers from "react-flip-numbers";
import { useWindowSize } from "react-use";
import Button from "../../components/common/Button";

import { getAudioList, initiateVolumeMeter, pauseAll, waitForVoice } from '../../utils/audios'
import { LibraryRecordButton } from '../neutral/RecordButton';
import wait, { delayAll } from "../../utils/wait";
import { setsEqual } from 'chart.js/helpers';
var speechConfig = SpeechSDK.SpeechConfig.fromSubscription("3e60cc9987ec41418be6de7cf1905fa2", "eastus");
speechConfig.setProperty(SpeechSDK.PropertyId.SpeechServiceConnection_EndSilenceTimeoutMs, "5000");
speechConfig.setProperty(SpeechSDK.PropertyId.SpeechServiceConnection_InitialSilenceTimeoutMs, "5000");

speechConfig.setProperty("SPEECH-PhraseTimeout", "100000");


function matchStrings(a, b, handleEndings = true) {
  let result = {};
  let i = 0;
  let j = 0
  var lastRead = null;
  while ((i < b.length) && (i < a.length)) {
    lastRead = `${a[i]}_${i}`.trim().replace(/[^A-Za-z0-9_ -]+/, '').toLowerCase();
    result[`${a[i]}${i}`] = "read";
    i++;
  }
  return [result, lastRead]
}

async function getMicClip({ microPhoneConfig: _micConfig, setStatus, setHasRecorded, audioStreamBegan, closeStream }) {
  const microPhoneConfig = { waitTime: 6000, timeOut: 2000, wrLength: 3, type: "norepeat", ...(_micConfig || {}) }
  console.log({ called: "getMicClip", microPhoneConfig })
  return await waitForVoice(microPhoneConfig.wrLength, 1, microPhoneConfig.type, microPhoneConfig.waitTime, {
    speechTimeOut: microPhoneConfig.timeOut,
    listening() {
      setStatus("recording")
      setHasRecorded && setHasRecorded(true)
    },
    empty() {
      setStatus("recording")
    },
    audioStreamBegan,
    closeStream
  });
}

// function TimeOutPopup({ onClose }) {
//   useEffect(() => {
//     pauseTimeOut = setTimeout(() => {
//       window.location.reload()
//     }, 60 * 1000 * 3)
//     return () => {
//       clearTimeout(pauseTimeOut)
//     }
//   }, [])
//   return <div className={styles.pausedPage}>
//     <h1>Timed Out</h1>
//     <Button noSoundCheck={true} processingLoader={false} onClick={async () => {
//       clearTimeout(pauseTimeOut)
//       onClose()
//     }} icon={"nextarrow"} border={"white"} background={"green"} title={`Continue`} />
//   </div>
// }


function useValidity() {
  const [status, setStatus] = useState(null)
  const [optionalGrowth, setIsOptionalGrowth] = useState(false)
  const [isEnded, setIsEnded] = useState(false)
  const [repeatId, setRepeatId] = useState(0)
  const silences = useRef(0)
  const [nextItem, setNextItem] = useState(null)
  const [nextPage, setNextPage] = useState(null)
  const [showsStatus, setShowsStatus] = useState(true)
  const [hasRecorded, setHasRecorded] = useState(false)
  const [sentenceResults, setSentenceResults] = useState(null)
  const [phonemeResults, setPhonemeResults] = useState(null)
  const [isPractice, setIsPractice] = useState(false)
  const [silenceBuzzing, setSilenceBuzzing] = useState()
  const [loading, setLoading] = useState(true);
  const [isPaused, setIsPaused] = useState(false);

  //bek
  const isCorrected = useRef(true)
  const tryAgainRef = useRef(false)

  const s3FieldsRef = useRef()
  const audioBlob = useRef()
  const metaBlob = useRef()
  const textBlob = useRef()

  const wrongCount = useRef(0)
  const submitInFlightRef = useRef(false)
  const navigate = useNavigate();
  const [practiceDetails, setPracticeDetails] = useState({})
  const startTime = useRef()



  const location = useLocation();
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [attempt, setAttempt] = useState(null);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState([]);





  // Get quiz data from location.state
  const quizzes = location.state?.quizzes || [];
  const book = location.state?.book || {};
  const progressId = location.state?.progressId || {};
  const pages = book?.pages || [];
  const bookTitle = location.state?.bookTitle || book?.title || "Story Quiz"; // Yishak
  const quiz = quizzes[0];
  const questions = quiz?.questions?.questions || [];
  console.log(quizzes);
  console.log(location.state);
  console.log(book);

  useEffect(() => {
    startQuiz();
  }, []);

  const triggerPausing = useCallback(async (pauseTimeOutRef, retrivePausedFunctionRef) => {
    await playSound('click')
    setIsPaused(true);
    try {
      retrivePausedFunctionRef.current = await delayAll();
    } catch (e) {
      console.error(e)
    }
    pauseTimeOutRef.current = setTimeout(async () => {
      localStorage.removeItem("token");
      window.location.reload()
    }, 60 * 1000 * 3)
  }, [setIsPaused]);

  const startQuiz = useCallback(async () => {
    // console.log('proooooooooooooooooooooooooooogres')
    // console.log(progressId)
    if (!progressId.progress.bookId) return;
    window.soundManager.cleanAllChannel();
    await initiateQuiz({ "bookId": progressId.progress.bookId })
      .then(data => {
        // console.log('quizzzz');
        // console.log(data.data.data);
        if (data.data.data.status === 'PASSED') {
          navigate('/result', {
            state: {
              score: data.data.data.attempt.score,
              total: 10,
              book: progressId,
              tryAgain: data.data.data.tryAgain,
              gems: data.data.data.gems
            }
          });
        } else {
          setAttempt(data.data.data);
          setCurrentQuestion(data.data.data.attempt.current)

        }
        setLoading(false);
        //  setProgressId(data.data.data);
      });
  }, []);


  const description = pages
    .flatMap(page => page.paragraphs.map(paragraph => paragraph.text))
    .join(' ');

  console.log(description);

  const handleAnswerSelect = (option) => {
    setSelectedAnswer(option);
    textBlob.current = String.fromCharCode(65 + option);

  };

  const handleNext = async () => {
    if (selectedAnswer !== null) {
      const newAnswers = [...answers, selectedAnswer];
      setAnswers(newAnswers);
      setStatus("processing");
      if (currentQuestion < questions.length - 1) {
        // setCurrentQuestion(currentQuestion + 1);
        // setSelectedAnswer(null);
      } else {
        // Quiz completed, calculate score
        // const correctCount = newAnswers.filter(answer => answer.correct).length;
        // Quiz completed, calculate score

        // const correctCount = newAnswers.filter((ans, idx) =>
        //   questions[idx].options[ans] === questions[idx].correctAnswer ||
        //   ans === questions[idx].correctAnswer
        // ).length;
        // startQuiz();

      }
    }
  };

  const question = questions[currentQuestion];
  const questionIndex = questions.findIndex(q => q.id === question.id);

  const [loadedData, setLoadedData] = useState(null)
  const [isTimeOutOpen, setIsTimeOutOpen] = useState(false)

  // const { countDown, ...countDownDetails } = useCountDown(null, true)

  const { countDown, state: countDownState, reset, start, stop, countDownId, countDownAmount } = useCountDown(60)



  //   useEffect(() => {
  //   reset(false, question.type === 'stt' ? 20 : 60, question.id);
  // }, [question.type, question.id]);

  const microphoneOperation = useCallback(async () => {
    console.log('atttttttempttttt')
    console.log(attempt)
    // if (question.type === 'stt' && countDownState !== "running") {
    reset(false, 25, question.id);
    //   start();
    // }
    s3FieldsRef.current = await LibraryinitVoice(2, question.id)
    var recognizer;
    var recognizingText = question.question;

    if (typeof question.question != "string") {
      recognizingText = question.question.join(" ")
    }
    setSentenceResults((results) => ({ ...results, [question.id]: null }))
    recognizingText = recognizingText.trim().replace(/[^A-Za-z0-9_ -]+/ig, '').toLowerCase()




    const blob = await getMicClip({
      microPhoneConfig: {
        waitTime: 35000,
        timeOut: 7000,
        wrLength: question.question.split(" ").length,
      },
      setStatus,
      setHasRecorded,
      audioStreamBegan(stream, endTheStream) {
        startTime.current = new Date()
        if (true) {

          var audioConfig = SpeechSDK.AudioConfig.fromStreamInput(stream);
          recognizer = new SpeechSDK.SpeechRecognizer(speechConfig, audioConfig);
          const phraseList = SpeechSDK.PhraseListGrammar.fromRecognizer(recognizer);
          var mainTarget = recognizingText.split(" ");
          for (let i = 0; i < mainTarget.length; i++) {
            phraseList.addPhrase(mainTarget[i]);
          }

          // const conn = SpeechSDK.Connection.fromRecognizer(recognizer);
          // conn.setMessageProperty("speech.context", "phraseDetection", {
          //     "INTERACTIVE": {
          //         "segmentation": {
          //             "mode": "custom",
          //             "segmentationSilenceTimeoutMs": 5000
          //         }
          //     },
          //     mode: "Interactive"
          // });

          // const pronunciationAssessmentConfig = new SpeechSDK.PronunciationAssessmentConfig(recognizingText,
          //     SpeechSDK.PronunciationAssessmentGradingSystem.HundredMark,
          //     SpeechSDK.PronunciationAssessmentGranularity.Word,
          //     "true")
          // pronunciationAssessmentConfig.properties.setProperty(SpeechSDK.PropertyId.PronunciationAssessment_EnableMiscue, "true")
          // pronunciationAssessmentConfig.applyTo(recognizer)

          var totalProcessedTextIs = []
          setSentenceResults((results) => ({ ...results, [question.id]: null }))
          var noticedWords = {};


          for (let i = 0; i < recognizingText.length; i++) {
            var word = mainTarget[i]
            noticedWords[i] = {
              word,
              noticed: false
            }
          }
          var allTexts = []
          var currentTextItem = "";
          var allTextPrevMerged = ""
          recognizer.recognizing = function (s, e) {

            // handle intermediate results
            var data = JSON.parse(e.result.json)

            // console.log("RECOGNIZing: Text=",data);

            if (typeof (e.result.text) == "string") {
              try {
                var prctext = e.result.text.trim().replace(/[^A-Za-z0-9_ -]+/ig, '').toLowerCase()
                currentTextItem = prctext

                var recognizedText = ([allTextPrevMerged, prctext]).filter(itm => itm?.length > 0).join(" ")
                var recognizedWords = recognizedText.split(" ")


                var [sResultItem, lastRead] = matchStrings(mainTarget, recognizedWords)
                if (lastRead) {
                  const lastReadEl = document.getElementById(lastRead);
                  if (lastReadEl) {
                    lastReadEl.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "start"
                    })
                  }
                }
                setSentenceResults((results) => ({
                  ...results, [question.id]: sResultItem
                }))
              } catch (e) {
                console.error(e)
              }
            }
            // handle intermediate results
          };

          var totalProcessedTexts = []
          var totalScorings = []
          var totalWords = []

          recognizer.recognized = function (s, e) {
            try {
              var data = JSON.parse(e.result.json)
              allTexts.push(currentTextItem)
              currentTextItem = null;
              allTextPrevMerged = allTexts.filter(itm => itm?.length > 0).join(" ")
              //console.log( data)
              if (data.RecognitionStatus == "Success") {
                //console.log("Finishing recognition...")

                // var nBest = data.NBest[0];
                // var pronunciation = nBest.PronunciationAssessment
                // // totalScorings.push([pronunciation.AccuracyScore,  pronunciation.CompletenessScore, pronunciation.FluencyScore, pronunciation.PronScore])
                // totalWords.push(...nBest.Words.filter(word=>word.PronunciationAssessment.AccuracyScore > 93).map((word, i)=>({index: i, word: word.Word,
                //     score:word.PronunciationAssessment.AccuracyScore ,
                //     error: word.PronunciationAssessment.ErrorType})))
                // if(data.DisplayText?.length > 0){
                //     totalProcessedTexts.push(data.DisplayText)
                //
                // }


                // var [accuracy, complete, fluency, pronunciationScore] = totalScorings.reduce((prev, curr)=>{
                //     return [prev[0] + curr[0], prev[1] + curr[1],prev[2] + curr[2],prev[3] + curr[3]]
                // }, [0,0,0,0])
                metaBlob.current = {
                  text: allTextPrevMerged,
                  duration: metaBlob.current?.duration ? metaBlob.current.duration + e.result.duration : e.result.duration,
                  wcpm: ((allTextPrevMerged.split(" ").length / (e.result.duration / 10000000)) * 60)
                }

                if ((allTextPrevMerged.split(" ").slice(-1) == recognizingText.split(" ").slice(-1))) {
                  endTheStream()
                }

              } else if (data.RecognitionStatus == "EndOfDictation") {
                endTheStream()
              }

            } catch (e) {
              console.error(e)
            }

          };
          recognizer.canceled = function (s, e) {
            // handle cancelation
            console.log("CANCELED: Reason=" + e.reason);
            endTheStream()
          };
          recognizer.startContinuousRecognitionAsync()


        }

      },
      async closeStream() {
        if (true) {
          await (new Promise((resolve, reject) => {
            recognizer.stopContinuousRecognitionAsync(resolve, reject)
          }))
        }
      }
    })
    await wait(1)
    if (true) {
      await (new Promise((resolve, reject) => {
        recognizer.stopContinuousRecognitionAsync(resolve, reject)

      }))
      recognizer.close()
    }
    if (blob) {
      if (blob == "done") {
        if (hasRecorded) { // yishak
          setStatus("processing")
        } else {
          setStatus("started")
        }

      } else {
        audioBlob.current = blob;
        setStatus("processing")

      }
    }
    else {
      setStatus("started")

      // if (silences.current < 1) {
      //   if (stageInfo.silencePrompt) {
      //     await soundManager.playFrom("status", stageInfo.silencePrompt)
      //   }
      //   silences.current += 1
      //   setStatus("started")
      // } else if (silences.current == 1) {
      //   if (stageInfo.silenceBuzz) {
      //     setSilenceBuzzing(true)
      //     await wait(15000)
      //   }
      //   silences.current += 1
      //   setStatus("started")

      // } else {
      //   setStatus("started")
      //   // window.location.reload()
      //   // audioBlob.current = blob;
      //   // setStatus("processing")
      // }

    }
  }, [question, currentQuestion]);

  useEffect(() => {
    audioBlob.current = null;
    textBlob.current = null;
    setHasRecorded(false)
    setShowsStatus(true)
    setSelectedAnswer(null);

    // silences.current = 0;
    // setPhonemeResults(null)
    /**
     *
     * @type {HTMLInputElement}
     */
    // var clearableInput = document.getElementById("clearableInputText")
    // if (clearableInput) {
    //   clearableInput.value = "";
    // }

    //setStatus(null)
  }, [question.id])

  const registerMicrophone = useCallback(() => {
    if (question.type === 'stt') {
      console.log('registerMicrophone');
      // setShowsStatus(false)
      return {
        onClick: microphoneOperation, // yishak
        micEnabled: (status === "started") && ((countDownState != "running") || ((countDown > 1))),
        status
      }
    } else {
      return {}
    }

  }, [status, microphoneOperation, countDownState, countDown])




  const [showSilentNotice, setShowSilentNotice] = useState(false)



  const submissionHandler = useCallback(async (data) => {
    if (submitInFlightRef.current) return;
    submitInFlightRef.current = true;
    try {
      stop()
      window.soundManager.cleanAllChannel();
      const result = await librarySubmitLesson(
        data,

        {
          // window.soundManager, 
          // useSoundManager,
          // soundManager: window.soundManager,
          // soundManager,

          async postTickPlay(result) {
            if (result.isCorrect) {
              // if (stageInfo.correctPrompt) {
              //   await soundManager.playFrom("status", stageInfo.correctPrompt)
              // }
            } else {
              if (data.uploadId || data.answer) {
                // if (stageInfo.wrongPrompt) {
                //   await soundManager.playFrom("status", stageInfo.wrongPrompt)
                // }
              }
            }
          },
          playProcessing: false,

        });
      console.log('resssssssssssssssssssuuuuuuuuuuuuulllllltttt')
      console.log(result)
      // Attempts already exhausted for this question (backend rejected with 422): don't crash,
      // treat it like a used-up attempt and move on to the next question.
      if (result?.maxAttemptsReached) {
        setStatus("fail")
        setSelectedAnswer(null)
        await wait(1000)
        setStatus('started')
        if (currentQuestion < questions.length - 1) {
          setCurrentQuestion(currentQuestion + 1);
          setSelectedAnswer(null);
        }
        return;
      }
      // Any other failure already routed to the error page (result is undefined) — bail safely
      // instead of dereferencing result.data below.
      if (!result) return;
      // Check if the answer is correct
      if (result?.data?.questionResult?.isCorrect) {
        // Move to next question if not last
        setStatus("pass")
        await wait(1000)
        setStatus('started')

        if (currentQuestion < questions.length - 1) {
          setCurrentQuestion(currentQuestion + 1);
          setSelectedAnswer(null);
        } else {
          // Quiz completed
          // navigate('/result', { state: { score: result.attempt.score, total: questions.length } });
        }
      } else {
        setStatus("fail")
        setSelectedAnswer(null);
        await wait(1000)
        setStatus('started')



        const attemptInfo = result.data.questionResult?.attemptInfo || {};

        // Check attempt number and remaining attempts
        if (
          attemptInfo.attemptNumber === 2 ||
          attemptInfo.remainingAttempts === 0
        ) {
          // Proceed to next question
          if (currentQuestion < questions.length - 1) {
            setCurrentQuestion(currentQuestion + 1);
            setSelectedAnswer(null);
          } else {
            // Quiz completed
            // ...handle completion...
          }
        }

        // Optionally show feedback or allow retry
        // e.g. setStatus("incorrect");
      }
      if (result.data.attempt.isComplete) {
        const correctAnswers = result.data.attempt.score;
        const correctCount = Math.round((correctAnswers / 100) * questions.length)

        navigate('/result', {
          state: {
            score: correctCount,
            total: questions.length,
            book: progressId,
            tryAgain: result.data.tryAgain,
            gems: result.data.gems
          }
        });
      }
      // if (result) {
      //   handleNext()
      // }
    } finally {
      submitInFlightRef.current = false;
    }

  }, [question, stop, setSelectedAnswer])


  const initiateQuestions = useCallback(() => {

    setStatus("started")
  }, [])







  // useEffect(() => {
  //   setNextPage(null)
  //   setNextItem(null)
  //   setIsEnded(false)
  //   setIsPractice(false)
  //   setStatus(null)
  // }, [trialId])

  useEffect(() => {

    if (currentQuestion && (countDownState == "complete") && (countDownId == question.id)) {
      if (hasRecorded) {
        stop()
      } else {
        // submissionHandler(lessonId, trialId, { uploadId: null, answer: textBlob.current })
        submissionHandler({ attemptId: attempt.attempt.id, answer: textBlob.current, questionIndex: questionIndex, uploadId: null })
      }
    }


  }, [question.id, countDownState, countDownId, hasRecorded])
  useEffect(() => {

    if (status == "processing") {
      stop()
    }


    (async () => {



      if (question.type === 'multiple_choice' && status === "started" && countDownState !== "running") {
        reset(false, 60, question.id);
        await window.soundManager.playImmediate("recording");
      }
      // if (question.type === 'stt' && status === "started" && countDownState !== "running") {
      //   reset(false, 20, question.id);

      // } else if (question.type === 'multiple_choice' && status === "started" && countDownState !== "running") {
      //   reset(false, 20, question.id);
      //   await window.soundManager.playImmediate("recording");
      // }
      if (question.type === 'stt' && status === "processing") {
        const { url, uploadId } = s3FieldsRef.current
        var isUploaded = false;
        window.soundManager.playSound("processing", "processing", true, 0.06)
        if (audioBlob.current) {
          await uploadToS3(url, audioBlob.current, "audio.wav", "audio/x-wav")
          isUploaded = true;
        }
        const dur = startTime.current ? (new Date() - startTime.current) : 0

        await submissionHandler({ attemptId: attempt.attempt.id, answer: '', questionIndex: questionIndex, uploadId: isUploaded ? uploadId : null, meta: metaBlob.current, wcpm: metaBlob.current?.wcpm, duration: dur / 1000 })
      } else if (question.type === 'multiple_choice' && status === "processing") {
        window.soundManager.playSound("processing", "processing", true, 0.06)
        await submissionHandler({ attemptId: attempt.attempt.id, questionIndex: questionIndex, answer: textBlob.current })
      }

      // if (question.type === 'stt') {
      //   if ((status === "started")) {

      //     // if ((!stageInfo.microphone) && (!itemDetails.microphone)) {
      //     //   await microphoneOperation()
      //     // } else {
      //     reset(false, (20), question.id)
      //     // }

      //   } else if (status === "processing") {
      //     const { url, uploadId } = s3FieldsRef.current
      //     var isUploaded = false;
      //     window.soundManager.playSound("processing", "processing", true, 0.06)
      //     if (audioBlob.current) {
      //       await uploadToS3(url, audioBlob.current, "audio.wav", "audio/x-wav")
      //       isUploaded = true;
      //     }
      //     const dur = startTime.current ? (new Date() - startTime.current) : 0

      //     await submissionHandler({ attemptId: attempt.attempt.id, answer: '', questionIndex: questionIndex, uploadId: isUploaded ? uploadId : null, meta: metaBlob.current, wcpm: metaBlob.current?.wcpm, duration: dur / 1000 })
      //   }
      // } else if (question.type === 'multiple_choice') {

      //   if (status === "started") {
      //     // if (!((itemDetails.timeOut || stageInfo.timeOut) === -1)) {
      //     //   if (stageInfo.subType === "letterSound") {
      //     //     const key = itemDetails.key.split("")[1].toLowerCase()
      //     //     await soundManager.playImmediate(`p1/part1-${key}`)
      //     //   }
      //     reset(false, (20), question.id)
      //     await window.soundManager.playImmediate("recording")

      //     // }

      //   } if (status === "processing") {
      //     window.soundManager.playSound("processing", "processing", true, 0.06)
      //     await submissionHandler({ attemptId: attempt.attempt.id, questionIndex: questionIndex, answer: textBlob.current })
      //   }
      // }

      // if (status === "started") {
      //   // console.debug("StageInfo= ", stageInfo)
      //   // await playInstructionsOptionally()

      // }

      // if ((itemDetails.type === "word")) {

      // if ((status === "started")) {

      //   // if (((!stageInfo.microphone) && (!itemDetails.microphone)) || (stageInfo.startImmediately)) {
      //   //   if (stageInfo.countDown) {
      //   //     reset(false, (itemDetails.timeOut || stageInfo.timeOut || 20), current)
      //   //   }
      //   await microphoneOperation()
      //   // } else {
      //   //   reset(false, (itemDetails.timeOut || stageInfo.timeOut || 20), current)
      //   // }


      // }
      // else if (status === "processing") {
      //   const { url, uploadId } = s3FieldsRef.current
      //   var isUploaded = false;
      //   window.soundManager.playSound("processing", "processing", true, 0.06);
      //   if (audioBlob.current) {
      //     await uploadToS3(url, audioBlob.current, "audio.wav", "audio/x-wav");
      //     isUploaded = true;
      //   }

      //   //         POST https://test.api.read21.org/student/library/quiz/submit
      //   // {
      //   // "attemptId": "e5829db3-080f-4491-be63-4caa5ba6eaf3",
      //   //     "questionIndex": 5,
      //   //     "answer": "B"
      //   // }

      //   await submissionHandler({ "attemptId": progressId.id, "questionIndex": 5, "answer": "B", uploadId: isUploaded ? uploadId : null });



      // }

    }
      // else if (itemDetails.type === "sentence") {
      //   if ((status === "started")) {

      //     if ((!stageInfo.microphone) && (!itemDetails.microphone)) {
      //       await microphoneOperation()
      //     } else {
      //       reset(false, (itemDetails.timeOut || stageInfo.timeOut || 20), current)
      //     }

      //   } else if (status === "processing") {
      //     const { url, uploadId } = s3FieldsRef.current
      //     var isUploaded = false;
      //     soundManager.playSound("processing", "processing", true, 0.06)
      //     if (audioBlob.current) {
      //       await uploadToS3(url, audioBlob.current, "audio.wav", "audio/x-wav")
      //       isUploaded = true;
      //     }
      //     const dur = startTime.current ? (new Date() - startTime.current) : 0
      //     await submissionHandler(lessonId, trialId, { uploadId: isUploaded ? uploadId : null, meta: metaBlob.current, wcpm: metaBlob.current?.wcpm, duration: dur / 1000 })
      //   }
      // } else if (itemDetails.type === "text") {

      //   if (status === "started") {
      //     if (!((itemDetails.timeOut || stageInfo.timeOut) === -1)) {
      //       if (stageInfo.subType === "letterSound") {
      //         const key = itemDetails.key.split("")[1].toLowerCase()
      //         await soundManager.playImmediate(`p1/part1-${key}`)
      //       }
      //       reset(false, (itemDetails.timeOut || stageInfo.timeOut || 20), current)
      //       await soundManager.playImmediate("recording")

      //     }

      //   } if (status === "processing") {
      //     soundManager.playSound("processing", "processing", true, 0.06)
      //     await submissionHandler(lessonId, trialId, { answer: textBlob.current })
      //   }
      // }
      // }
    )()





  }, [status, question.id]);





  // const stopPresentable = useMemo(() => status && (status !== "started"), [status])
  return {
    bookTitle, // yishak
    showsStatus,
    selectedAnswer,
    setSelectedAnswer,
    attempt,
    setAttempt,
    currentQuestion,
    setCurrentQuestion,
    answers,
    setAnswers,
    quizzes,
    book,
    progressId,
    pages,
    quiz,
    questions,
    question,
    description,
    loading,
    handleAnswerSelect,
    handleNext,
    status, countDownState, countDown,

    //bek
    isCorrected,
    tryAgainRef,
    setShowSilentNotice,

    initiateQuestions,
    registerMicrophone,

    sentenceResults,

    // Pause functionality
    isPaused,
    setIsPaused,
    triggerPausing,

  }
}

const Quiz2 = () => {
  // Pause functionality variables
  const pauseTimeOutRef = useRef(null);
  const retrivePausedFunctionRef = useRef(null);

  // const questions = [
  //   {
  //     id: 1,
  //     number: "01",
  //     question: "What is the most important thing in school?",
  //     options: [
  //       { id: 'A', text: 'Finishing first', correct: false },
  //       { id: 'B', text: 'Doing your best', correct: true },
  //       { id: 'C', text: 'Running as fast as you can', correct: false }
  //     ]
  //   },
  //   {
  //     id: 2,
  //     number: "02",
  //     question: "Why is doing your best more important than being first?",
  //     options: [
  //       { id: 'A', text: 'Because it helps you learn better', correct: true },
  //       { id: 'B', text: 'Because it makes you faster', correct: false },
  //       { id: 'C', text: 'Because teachers like it more', correct: false }
  //     ]
  //   },
  //   {
  //     id: 3,
  //     number: "03",
  //     question: "When you take your time to do good work, how do you feel?",
  //     options: [
  //       { id: 'A', text: 'Disappointed because you\'re slow', correct: false },
  //       { id: 'B', text: 'Proud of what you accomplished', correct: true },
  //       { id: 'C', text: 'Worried about being last', correct: false }
  //     ]
  //   },
  //   {
  //     id: 4,
  //     number: "04",
  //     question: "What happens when you rush to be first?",
  //     options: [
  //       { id: 'A', text: 'You always do your best work', correct: false },
  //       { id: 'B', text: 'You might make mistakes or forget something', correct: true },
  //       { id: 'C', text: 'You become a better student', correct: false }
  //     ]
  //   },
  //   {
  //     id: 5,
  //     number: "05",
  //     question: "What should you ask yourself when doing an assignment?",
  //     options: [
  //       { id: 'A', text: 'Am I the fastest?', correct: false },
  //       { id: 'B', text: 'Am I doing my best?', correct: true },
  //       { id: 'C', text: 'Am I finished first?', correct: false }
  //     ]
  //   }
  // ];
  // Collect all paragraph texts into one description




  // const submitResult = useCallback((data, dontPlayStatus = false, callback) => {
  //   return new Promise(async (resolve, reject) => {
  //     try {
  //       const { id } = loadedData;
  //       // countDownDetails?.stop?.()
  //       setCurrentStatus("processing")
  //       const res = await submitActivity(id, {
  //         ...data
  //       }, () => { }, {
  //         soundManager,
  //         dontPlayStatus
  //       });

  //       if (callback) {
  //         await callback(res)
  //       }

  //       setCurrentStatus(res.isCorrect ? "correct" : "incorrect")
  //       resolve(res)
  //       await wait(1000)

  //       setCurrentStatus(null)



  //       setIsQuestioning(false)

  //       if (res.isEnd) {
  //         onEnd()
  //       } else {
  //         if (res.retry) {
  //           setRepeatCount(res.triedAmount)
  //           setIsQuestioning(true)
  //         } else {
  //           setRepeatCount(0)
  //           setTimeout(() => {
  //             setQuestionIndex(res.nextIndex)
  //             setIsQuestioning(true)
  //           }, 1000)
  //         }

  //       }



  //     } catch (e) {
  //       reject(e)
  //     }

  //   });



  // }, [loadedData]);








  // useEffect(() => {
  //   (async () => {
  //     if (countDownDetails?.state === "complete") {
  //       await wait(500)
  //       if (countDownDetails?.timerMeta) {
  //         await countDownDetails?.timerMeta()
  //       } else {
  //         // if (submitButton?.onClick) {
  //         //     await submitButton?.onClick()
  //         // }
  //         setIsTimeOutOpen(true)
  //         await playSound("click")
  //         try {
  //           const retrivePausage = await delayAll();
  //           retrivePausedFunction = async () => {
  //             await retrivePausage()
  //             await submitButton?.onClick()

  //           };
  //         } catch (e) {
  //           console.error(e)
  //         }
  //       }


  //     }
  //   })().catch(alert)

  // }, [countDownDetails?.state, submitResult])



  // const pauseAndResume = useCallback(async () => {

  //   window.location.reload()
  // }, []);




  // console.log({ ...registerMicrophone(true) });

  useEffect(() => {
    (async () => {
      await wait(100);
      initiateQuestions();
    })()
  }, [])




  const {
    bookTitle, // yishak
    showsStatus,
    status,
    countDownState,
    countDown,
    selectedAnswer,
    setSelectedAnswer,
    attempt,
    setAttempt,
    currentQuestion,
    setCurrentQuestion,
    answers,
    setAnswers,
    quizzes,
    book,
    progressId,
    pages,
    quiz,
    questions,
    question,
    description,
    loading,
    handleAnswerSelect,
    handleNext,

    //bek
    isCorrected,
    tryAgainRef,
    setShowSilentNotice,

    initiateQuestions,
    registerMicrophone,

    sentenceResults,

    // Pause functionality
    isPaused,
    setIsPaused,
    triggerPausing,

  } = useValidity();


  const windowSize = useWindowSize();

  if (loading) return (
    <div className="h-screen flex items-center justify-center bg-white">
      <span className="text-2xl text-[#3D74B6] font-bold">Loading...</span>
    </div>
  ); // Or a loading spinner


  if (!question) {
    return (
      <div className="h-screen flex items-center justify-center bg-white">
        <span className="text-2xl text-[#3D74B6] font-bold">No quiz found.</span>
      </div>
    );
  }

  return (
    <div className="h-screen w-screen overflow-hidden bg-[#3D74B6] flex flex-col">
      {/* Header */}
      <header className="bg-[#3D74B6] shadow-lg">
        <div className="px-4 md:px-20 py-4 flex justify-between items-center">
          <button
            onClick={async () => {
              await triggerPausing(pauseTimeOutRef, retrivePausedFunctionRef)
            }}
            disabled={status === "recording"}
            className={clsx(styles.pauseButton, status === "recording" && styles.isButtonDisabled)}
          >
            <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M4 0H2C1.46957 0 0.96086 0.210714 0.585787 0.585786C0.210714 0.960859 0 1.46957 0 2V18C0 18.5304 0.210714 19.0391 0.585787 19.4142C0.96086 19.7893 1.46957 20 2 20H4C4.53043 20 5.03914 19.7893 5.41421 19.4142C5.78929 19.0391 6 18.5304 6 18V2C6 1.46957 5.78929 0.960859 5.41421 0.585786C5.03914 0.210714 4.53043 0 4 0V0ZM14 0H12C11.4696 0 10.9609 0.210714 10.5858 0.585786C10.2107 0.960859 10 1.46957 10 2V18C10 18.5304 10.2107 19.0391 10.5858 19.4142C10.9609 19.7893 11.4696 20 12 20H14C14.5304 20 15.0391 19.7893 15.4142 19.4142C15.7893 19.0391 16 18.5304 16 18V2C16 1.46957 15.7893 0.960859 15.4142 0.585786C15.0391 0.210714 14.5304 0 14 0V0Z"
                fill="white" />
            </svg>
          </button>
          <h1 className="text-2xl md:text-4xl font-['KG_Primary_Penmanship'] text-[#FBF5DE] text-center flex-1">
            {bookTitle}
          </h1>
          <div className="w-[70px]"></div> {/* Spacer to center the title */}
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center px-2 md:px-12 py-2 md:py-6 overflow-hidden">
        {/* {
          isTimeOutOpen && <TimeOutPopup onClose={() => {
            retrivePausedFunction?.()
            setIsTimeOutOpen(false)
          }} />
        } */}
        {
          (((showsStatus) || (countDownState === "running"))) && (question.type === 'multiple_choice') &&
          <div className={clsx(styles.actionContainer, ((status && (status != "started")) || (countDownState === "running")) && styles.active, status && styles[status], (countDownState === "running") && styles.countingDown)}>
            <div className={styles.contentContainer}>
              {/* {
                        status == "recording" && <RecordIcon />
                    } */}
              {
                status == "processing" && <Lottie
                  loop={true}
                  options={{
                    loop: true,
                    autoplay: true,
                    animationData: processingAnimation,
                  }}
                  width={(windowSize.width > 900) ? 80 : 60}
                  height={(windowSize.width > 900) ? 80 : 60}
                />
              }
              {
                status == "pass" && <CorrectIcon />
              }
              {
                status == "fail" && <WrongIcon />
              }
              {
                (countDownState == "running") && <div className={styles.countDownContainer}>
                  <svg width={20} height={20} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M77 5L95 19.4M23 5L5 19.4M80.6 87.8L87.8 95M19.4 87.8L12.2 95M51.8 41V59L41 66.2M87.8 57.2C87.8 78.0764 70.8764 95 50 95C29.1236 95 12.2 78.0764 12.2 57.2C12.2 36.3236 29.1236 19.4 50 19.4C70.8764 19.4 87.8 36.3236 87.8 57.2Z"
                      stroke="white"
                      stroke-width="10"
                      stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                  <h1><FlipNumbers height={35} width={24} numberStyles={styles.numberStyles} color="white" play numbers={(countDown > 60) ? formatTime(countDown) : countDown.toString()} /></h1>
                </div>
              }
            </div>

          </div>
        }
        {
          (((showsStatus) || (countDownState === "running"))) && (question.type === 'stt' && status !== "started") &&
          <div className={clsx(styles.actionContainer, ((status && (status != "started")) || (countDownState === "running")) && styles.active, status && styles[status], (countDownState === "running") && styles.countingDown)}>
            <div className={styles.contentContainer}>
              {/* {
                        status == "recording" && <RecordIcon />
                    } */}
              {
                status == "processing" && <Lottie
                  loop={true}
                  options={{
                    loop: true,
                    autoplay: true,
                    animationData: processingAnimation,
                  }}
                  width={(windowSize.width > 900) ? 80 : 60}
                  height={(windowSize.width > 900) ? 80 : 60}
                />
              }
              {
                status == "pass" && <CorrectIcon />
              }
              {
                status == "fail" && <WrongIcon />
              }
              {
                (countDownState == "running") && <div className={styles.countDownContainer}>
                  <svg width={20} height={20} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M77 5L95 19.4M23 5L5 19.4M80.6 87.8L87.8 95M19.4 87.8L12.2 95M51.8 41V59L41 66.2M87.8 57.2C87.8 78.0764 70.8764 95 50 95C29.1236 95 12.2 78.0764 12.2 57.2C12.2 36.3236 29.1236 19.4 50 19.4C70.8764 19.4 87.8 36.3236 87.8 57.2Z"
                      stroke="white"
                      stroke-width="10"
                      stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                  <h1><FlipNumbers height={35} width={24} numberStyles={styles.numberStyles} color="white" play numbers={(countDown > 60) ? formatTime(countDown) : countDown.toString()} /></h1>
                </div>
              }
            </div>

          </div>
        }
        <div className="w-full max-w-7xl flex flex-col h-full justify-center">
          {/* Quiz Interface */}
          <div className=" rounded-[40px] p-2 md:p-8 relative overflow-hidden flex-1 flex flex-col">
            {/* Background decorative circles */}
            {/* <div className="absolute inset-0">
              <div className="absolute top-20 right-32 w-64 h-64 bg-white/10 rounded-full"></div>
              <div className="absolute bottom-16 left-24 w-48 h-48 bg-white/10 rounded-full"></div>
              <div className="absolute top-1/2 left-1/3 w-32 h-32 bg-white/5 rounded-full"></div>
            </div> */}

            <div className="relative z-10 flex-1 flex flex-col">
              {/* Quiz Content */}
              <div className="bg-white/95 backdrop-blur-sm rounded-[30px] overflow-auto scrollbar-hide flex-1 flex flex-row h-full min-h-[300px]"

              >
                {/* {
                  ((countDownState == "running")) && <div className={styles.countDownContainer}>
                    <svg width={20} height={20} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M77 5L95 19.4M23 5L5 19.4M80.6 87.8L87.8 95M19.4 87.8L12.2 95M51.8 41V59L41 66.2M87.8 57.2C87.8 78.0764 70.8764 95 50 95C29.1236 95 12.2 78.0764 12.2 57.2C12.2 36.3236 29.1236 19.4 50 19.4C70.8764 19.4 87.8 36.3236 87.8 57.2Z"
                        stroke="white"
                        stroke-width="10"
                        stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                    <h1><FlipNumbers height={35} width={24} numberStyles={styles.numberStyles} color="white" play numbers={(countDown > 60) ? formatTime(countDown) : countDown.toString()} /></h1>
                  </div>
                } */}
                <div className="flex h-full">
                  {/* Story Text Section */}
                  <div className="basis-1/2 p-4 md:p-12 bg-[#F2F2F2] border-r-2 border-gray-300 overflow-auto hide-scrollbar flex flex-col" style={{
                    height: "100%",
                    scrollbarWidth: "none",           // Firefox
                    msOverflowStyle: "none"           // IE 10+
                  }}>
                    <style>
                      {`
      .hide-scrollbar::-webkit-scrollbar {
        display: none;
      }
    `}
                    </style>
                    <div className="prose max-w-none flex flex-col h-full">
                      <h2 className="text-xl md:text-2xl font-['KG_Primary_Penmanship'] text-[#000] leading-relaxed mb-4 md:mb-8 font-bold">
                        {/* Doing Your Best is What Matters Most! */}
                        {bookTitle}
                      </h2>
                      <div className="space-y-4 md:space-y-6 text-base md:text-xl/10 font-['KG_Primary_Penmanship'] text-[#000] px-8 leading-[3rem] overflow-auto hide-scrollbar" style={{
                        maxHeight: "60vh", // Adjust height as needed
                        scrollbarWidth: "none", // Firefox
                        msOverflowStyle: "none" // IE 10+
                      }}>
                        <style>
                          {`
      .hide-scrollbar::-webkit-scrollbar {
        display: none;
      }
    `}
                        </style>
                        {/* <p>{location.state?.book?.description}</p> */}
                        <p>{description}</p>
                        {/* <p>Have you ever raced to be first in line or tried to finish a test as fast as possible? It feels exciting to win, but is being first the most important thing?</p>

                        <p>Some people always want to be first. They rush to finish their work, run to the front of the line, and make sure everyone knows they finished first. But sometimes, rushing can lead to mistakes, accidents, or missing important details. If you move too fast, you might trip, forget something, or not do your best work.</p>
                         */}
                      </div>
                      <div className="mt-auto text-center">
                        <div className="flex justify-center gap-2 md:gap-4">
                          {questions.map((_, index) => (
                            <div
                              key={index}
                              className={`w-3 h-3 md:w-4 md:h-4 rounded-full ${index === currentQuestion
                                ? 'bg-[#3D74B6]'
                                : index < currentQuestion
                                  ? 'bg-[#B4E50D]'
                                  : 'bg-gray-300'
                                }`}
                            ></div>
                          ))}
                        </div>
                        {/* <p className="mt-4 text-xl text-[#374957] font-['Cheese_Matcha']">
              Question {currentQuestion + 1} of {questions.length}
            </p> */}
                      </div>
                    </div>
                  </div>

                  {/* Quiz Section */}
                  <div className="basis-1/2 p-4 md:p-8 bg-[#F2F2F2] overflow-auto scrollbar-hide flex flex-col justify-start"
                    style={{
                      maxHeight: "80vh",
                      scrollbarWidth: "none",           // Firefox
                      msOverflowStyle: "none"           // IE 10+
                    }}>
                    <style>
                      {`
      .hide-scrollbar::-webkit-scrollbar {
        display: none;
      }
    `}
                    </style>
                    <div className="space-y-6 md:space-y-8">
                      {/* Question Header */}
                      <div className="flex items-start gap-4 md:gap-8">
                        {/* <span className="text-4xl font-['Cheese_Matcha'] text-[#374957] leading-none">
                          {question.number}
                        </span>
                        <h2 className="text-2xl font-['Cheese_Matcha'] text-[#374957] flex-1 leading-normal mt-4 font-bold">
                          {question.question}
                        </h2> */}
                        <span className="text-2xl md:text-4xl font-['KG_Primary_Penmanship'] text-[#374957] leading-none">
                          {currentQuestion + 1 < 10 ? `0${currentQuestion + 1}` : currentQuestion + 1}
                        </span>
                        <h2 className="text-lg md:text-2xl font-['KG_Primary_Penmanship'] text-[#374957] flex-1 leading-normal p-4 mt-2 md:mt-4 font-bold">
                          {question.question}
                        </h2>
                      </div>

                      {/* Answer Options */}

                      <div className="space-y-3 md:space-y-4">
                        {question.type === 'multiple_choice' ? (
                          question.options.map((option, index) => (
                            <button
                              key={index}
                              onClick={() => handleAnswerSelect(index)}
                              className={`w-full p-3 rounded-[20px] border-2 text-left transition-all ${selectedAnswer === index
                                ? 'bg-[#3D74B6] border-[#3D74B6] text-white shadow-lg'
                                : 'bg-white border-gray-300 hover:bg-gray-50 text-[#374957]'
                                }`}
                            >
                              <span className="text-base md:text-xl font-['KG_Primary_Penmanship']">
                                {String.fromCharCode(65 + index)}. {option}
                              </span>
                            </button>
                          ))
                        ) : question.type === 'stt' ? (
                          <>
                            {/* <button
                              className="w-full p-3 rounded-[20px] text-white flex items-center justify-center text-base md:text-xl font-['Cheese_Matcha']"
                            // onClick={() => {
                            //   initiateQuestions();
                            // }}
                            > */}

                            <div className="flex justify-center">
                              <LibraryRecordButton
                                {...registerMicrophone()}
                              />
                            </div>
                            {/* <LibraryRecordButton
                              {...registerMicrophone()}

                            // status={status}
                            /> */}

                            {/* <span role="img" aria-label="microphone" className="mr-2">🎤</span>
                            Speak your answer */}
                            {/* </button> */}
                            <span className="text-base md:text-xl font-['KG_Primary_Penmanship'] font-bold text-center justify-center items-center flex pt-12 md:pt-14">
                              Click the mic and read the question out loud.
                            </span>
                            {/* <span className="text-base md:text-xl font-['KG_Primary_Penmanship'] font-bold text-center justify-center items-center flex pt-12 md:pt-14">
                              Click the mic and read the question out loud.
                            </span> */}
                          </>
                        ) : null}
                      </div>
                      {/* <div className="space-y-4">
                        {question.options.map((option, index) => (
                          <button
                            key={index}
                            onClick={() => handleAnswerSelect(index)}
                            className={`w-full p-3 rounded-[20px] border-2 text-left transition-all ${selectedAnswer === index
                              ? 'bg-[#3D74B6] border-[#3D74B6] text-white shadow-lg'
                              : 'bg-white border-gray-300 hover:bg-gray-50 text-[#374957]'
                              }`}
                          >
                            <span className="text-xl font-['Cheese_Matcha']">
                              {String.fromCharCode(65 + index)}. {option}
                            </span>
                          </button>
                        ))}
                      </div> */}

                      {/* Next Button */}
                      {question.type !== 'stt' ? <div className="pt-2 md:pt-4">
                        <button
                          onClick={handleNext}
                          disabled={selectedAnswer === null}
                          className={`w-full py-3 rounded-full text-xl md:text-3xl font-medium transition-all ${selectedAnswer !== null
                            ? 'bg-[#B4E50D] text-[#374957] shadow-button hover:shadow-lg'
                            : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                            }`}
                        >
                          {(currentQuestion < questions.length - 1 ? 'Next' : 'Finish Quiz')}
                        </button>
                      </div> : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Progress Indicator */}
          {/* <div className="mt-8 text-center">
            <div className="inline-flex gap-4">
              {questions.map((_, index) => (
                <div 
                  key={index}
                  className={`w-4 h-4 rounded-full ${
                    index === currentQuestion 
                      ? 'bg-[#3D74B6]' 
                      : index < currentQuestion .
                        ? 'bg-[#B4E50D]' 
                        : 'bg-gray-300'
                  }`}
                ></div>
              ))}
            </div>
            <p className="mt-4 text-xl text-[#374957] font-['Cheese_Matcha']">
              Question {currentQuestion + 1} of {questions.length}
            </p>
          </div> */}
        </div>
      </main>

      {/* Pause Overlay */}
      {isPaused && (
        <div className={styles.pausedPage}>
          <h1>Paused</h1>
          <Button
            noSoundCheck={true}
            processingLoader={false}
            onClick={async () => {
              clearTimeout(pauseTimeOutRef.current)
              await retrivePausedFunctionRef.current?.();
              setIsPaused(false)
            }}
            icon={"nextarrow"}
            border={"white"}
            background={"green"}
            title={`Continue`}
          />
        </div>
      )}
    </div>
  );
};

export default Quiz2;
